<template>
  <ul class="features">
    <li
      v-for="(feature, i) in features"
      :key="i"
      class="feature"
      itemprop="amenityFeature"
      itemscope
      itemtype="https://schema.org/LocationFeatureSpecification"
    >
      <div class="icon is-size-auto">
        <SpriteSymbol :name="feature.icon || 'check'" class="size-[1em]" />
      </div>
      <div itemprop="name" class="feature-title">{{ feature.text }}</div>
      <meta itemprop="value" content="True" />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { NuxtSvgSpriteSymbol } from '#nuxt-svg-icon-sprite/runtime'

export interface FeatureItem {
  text: string
  icon?: NuxtSvgSpriteSymbol
}

withDefaults(
  defineProps<{
    features?: FeatureItem[]
  }>(),
  {
    features: () => [],
  },
)
</script>

<style lang="postcss">
.features {
  @apply grid text-size-6;
  grid-gap: 0.5rem;
  grid-template-columns: 1fr;
  @screen desktop {
    grid-gap: 1rem;
  }
}
.feature {
  @apply flex items-center;
  &:last-child {
    @apply flex-1;
  }
  .icon {
    @apply mr-[0.5em] flex items-center text-size-5 text-scheme-invert;
    @apply tablet:text-size-4-5;
  }
}
.feature-title {
  @apply font-bold leading-[1] text-scheme-invert;
}
</style>
